import React, { FC } from 'react';
import './App.css';
import { Switch, BrowserRouter, Route, MemoryRouter, useLocation, } from 'react-router-dom';
import VideoTest from './pages/VideoTest';
import SlideTest from './pages/SlideTest';
import Main from 'pages/Main';
import IntroductionRoutes from 'routes/IntroductionRoutes';
import IComponentProps from 'interfaces/IComponentProps';
import GlobalStyle from 'const/style/GlobalStyle';
import LoginPage from 'pages/LoginPage';
import ApplicantHome from 'pages/ApplicantHome';
import FileUploadPage from 'pages/FileUploadPage';
import PresentationRoutes from 'routes/PresentationRoutes';
import ErrorBoundary from 'components/ErrorBoundary';
import ErrorPage from 'pages/ErrorPage';
import PrivacyTerms from 'pages/PrivacyTerms';
import StepGuide from 'pages/StepGuide';
import { detect } from 'detect-browser';
import UnSupportBrowser from 'pages/UnSupportBrowser';
import ContinuePT from 'pages/ContinuePT';
import AuthRoute from 'components/AuthRoute';
import NotFound from 'pages/NotFound';
import PtCountErrorModal from 'components/PtCountErrorModal';
import Login from 'models/Login';
import { inject, observer } from 'mobx-react';
import UserStatusType from 'consts/UserStatusType';

const browser = detect();

const RouterInContext: FC<IComponentProps> = ({ children }) => {
  //TODO: 임시 처리라 나중에 MemoryRouter로 바꿔줘야함 !!꼭..!!
  const location = useLocation();
  return (
    process.env.REACT_APP_ENV === 'development' ?
      <BrowserRouter>
        {children}
      </BrowserRouter>
      :
      <MemoryRouter initialEntries={['/', location.pathname]} initialIndex={
        [
          '/presentation',
          '/finale',
          '/streamError',
        ].includes(location.pathname)? 0 : 1}>
        {children}
      </MemoryRouter>
  )
}

declare global {
  interface Window { calibration: any; }
}

interface IAppProps {
  loginInfo?: Login;
}

const App: FC<IAppProps> = ({loginInfo = new Login()}) => {
  if (browser && browser.name !== 'chrome')
    return <><GlobalStyle /><UnSupportBrowser /></>

  return (
    <div className="App">
      <GlobalStyle />
      <BrowserRouter>
        <Switch>
          <Route
            path={'/privacyterms'}
            component={PrivacyTerms}
          />
          <AuthRoute
            path={'/stepguide'}
            component={StepGuide}
          />
          <Route
            path='/error'
            component={ErrorPage}
          />
          <RouterInContext>
            <ErrorBoundary>
              <Switch>
                <Route
                  path={'/login'}
                  component={LoginPage}
                />
                <AuthRoute
                  path={'/video'}
                  component={VideoTest}
                />
                <AuthRoute
                  path={'/slide'}
                  component={SlideTest}
                />
                <AuthRoute
                  exact
                  path='/home'
                  component={ApplicantHome}
                />
                <AuthRoute
                  exact
                  path='/debug'
                  component={Main}
                />
                <AuthRoute
                  path='/introduction**'
                  component={IntroductionRoutes}
                />
                <AuthRoute
                  exact
                  path='/'
                  component={ApplicantHome}
                />
                <AuthRoute
                  path='/upload'
                  component={FileUploadPage}
                />
                <AuthRoute
                  path={'/privacyterms'}
                  component={PrivacyTerms}
                />
                <AuthRoute
                  path={'/stepguide'}
                  component={StepGuide}
                />
                <AuthRoute
                  path={'/continuePT'}
                  component={ContinuePT}
                />
                <PresentationRoutes />
              </Switch>
              <PtCountErrorModal 
                open={!loginInfo.ptCountCheck}
                onClose={()=>loginInfo.logout()}
              />
            </ErrorBoundary>
          </RouterInContext>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default inject('loginInfo')(observer(App));